// extracted by mini-css-extract-plugin
export var dismissOverlay = "_bh-b";
export var interactivePassthrough = "_bh-3";
export var modal = "_bh-d";
export var modalBackdrop = "_bh-c";
export var modalBody = "_bh-j";
export var modalDescription = "_bh-m";
export var modalEnter = "_bh-e";
export var modalFooter = "_bh-n";
export var modalHeaderText = "_bh-h";
export var modalIconCircle = "_bh-i";
export var modalIconHeader = "_bh-g";
export var modalImage = "_bh-f";
export var modalSectionLabel = "_bh-k";
export var modalTitle = "_bh-l";
export var pulse = "_bh-1";
export var pulseBorder = "_bh-2";
export var spotlight = "_bh-0";
export var tooltip = "_bh-4";
export var tooltipButtons = "_bh-9";
export var tooltipDescription = "_bh-6";
export var tooltipFooter = "_bh-7";
export var tooltipInteractivePill = "_bh-a";
export var tooltipStepIndicator = "_bh-8";
export var tooltipTitle = "_bh-5";